import React from "react";
import Async from 'react-select/async';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Table,
    Input,
    UncontrolledTooltip,
    FormGroup,
    Label
} from "reactstrap";

// Requests
import { getSellersRequest, deleteSellerRequest } from "api/seller";
import { getBrokersRequest } from "api/broker";
// Helpers
import { hasPermission } from "helpers/auth";
// Components
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
class Sellers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          sellers: null,
          alert: null,
          total: 0,
          pages: 0,
          current_page: 0,
          start_page: 0,
          end_page: 9,
          first_page: 0,
          last_page: 0,
          deleteSellerId: '',
          filters: {limit: 25,},
          filtersBrokers: {},
          selectedBroker: null,
          loading: true
        }
        this.timeout = null;
    }

    async componentDidMount() {
        await this.getSellers()
        await this.loadBrokers()
    }

    getSellers = async () => {
        this.setState({loading: true})
        const { filters } = this.state;
        console.log(filters)
        const SellersObj = await getSellersRequest(filters);
        const sellers = SellersObj.sellers;
        const total = SellersObj.total;
        const pages = Math.ceil(total / filters.limit);
        const last_page = pages - 1;
        const end_page = pages > 10 ? 9 : pages - 1;

        this.setState({
            sellers,
            total,
            pages,
            last_page,
            end_page,
            loading: false
        })
    }

    onChangeSearch = (event) => {
        const { filters } = this.state;	
		this.setState({
            filters: {
                ...filters,
                search: event.target.value,
                page: 0,
            }
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getSellers();
		}, 300);
    }

    goTo = (path) => this.props.history.push(path);

    openConfirmation = (id) => () => {
		this.setState({
			deleteSellerId: id
		});
		this.deleteConfirmationModal.toggle();
    }

    onSelectChange = (key) => (object) => {
		const { filters } = this.state; 

		if(!object) {
            this.setState({
                filters: {...filters, [key]: ""},
				selectedBroker: null
            }, () => {
                this.getSellers();
            })
            return;
        }


		this.setState({
			filters: {...filters, [key]: object.value},
			selectedBroker: object
		}, () => {
			this.getSellers();
		})
	}

    loadBrokers = async (search, callback) => {
		const { filtersBrokers } = this.state;

		this.setState({
			filtersBrokers: {
				...filtersBrokers,
				search
			}
		})
		if(search) {
			const brokerResponse = await getBrokersRequest(filtersBrokers);
			const brokers = brokerResponse.brokers.map(broker => {
				return {
					data: broker,
					label: `${broker.name}`,
					value: broker._id
				}
			})
			callback(brokers);
		}
	}
    
    deleteSeller = async () => {
		const { deleteSellerId } = this.state;
        await deleteSellerRequest(deleteSellerId);
        this.getSellers()
	}

    render() {

        const {
            sellers,
            filters,
            selectedBroker,
            loading
        } = this.state;

        const {
            search
        } = filters;

        return (
            <>
                <div className="content">
                <Row>
                    <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle className="d-inline-block" tag="h4">
                                Sellers
                            </CardTitle>
                            {hasPermission('CreateSeller') ? <Button className="pull-right mb-3 add-btn" color="primary" onClick={() => this.goTo('/seller/create')}><i className="tim-icons icon-simple-add" /> Seller</Button> : null}
                            
                            <FormGroup>
                                <Label>Seller</Label>
                                <Input placeholder="Search Sellers..." value={search} type="text" onChange={this.onChangeSearch}></Input>
                            </FormGroup>
                            <FormGroup>
                                <Label>Broker</Label>
                                <Async
                                    clearValue={""}
                                    value={selectedBroker}
                                    name="broker"
                                    options={[]}
                                    loadOptions={this.loadBrokers}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={this.onSelectChange('brokerId')}
                                    placeholder="Search by broker..."
                                    isClearable={true}
                                />
                            </FormGroup>
                        </CardHeader>
                        <CardBody>
                        <Table responsive>
                            <thead className="text-primary">
                            <tr>
                                <th>Name</th>
                                <th>Broker</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th className="text-right">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                                {loading ?
                                <tr>
                                    <td colSpan="12">Loading...</td>
                                </tr>
                                :
                                sellers && sellers.length > 0 ? 
                                    sellers.map((seller) => {
                                        return (
                                            <tr key={seller._id}>
                                                <td>{`${seller.first_name} ${seller.last_name}`}</td>
                                                <td>{seller.broker ? seller.broker.name : "N/A"}</td>
                                                <td>{seller.email || "N/A"}</td>
                                                <td>{seller.phone || "N/A"}</td>
                                                <td className="text-right">
                                                    <Button
                                                        className="btn-link btn-icon"
                                                        color="success"
                                                        id={`tooltip-view-${seller._id}`}
                                                        size="sm"
                                                        onClick={() => this.goTo(`/seller?id=${seller._id}`)}
                                                    >
                                                        <i className="tim-icons icon-zoom-split" />
                                                    </Button>
                                                    <UncontrolledTooltip
                                                        delay={0}
                                                        target={`tooltip-view-${seller._id}`}
                                                    >
                                                        View
                                                    </UncontrolledTooltip>
                                                    {hasPermission('EditSeller') ? <>
                                                        <Button
                                                            className="btn-link btn-icon"
                                                            color="info"
                                                            id={`tooltip-edit-${seller._id}`}
                                                            size="sm"
                                                            onClick={() => this.goTo(`/seller/edit?id=${seller._id}`)}
                                                        >
                                                            <i className="tim-icons icon-pencil" />
                                                        </Button>
                                                        <UncontrolledTooltip
                                                            delay={0}
                                                            target={`tooltip-edit-${seller._id}`}
                                                        >
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        <Button
                                                            className="btn-link btn-icon"
                                                            color="danger"
                                                            id={`tooltip-delete-${seller._id}`}
                                                            size="sm"
                                                            onClick={this.openConfirmation(seller._id)}
                                                        >
                                                            <i className="tim-icons icon-simple-remove" />
                                                        </Button>
                                                        <UncontrolledTooltip
                                                            delay={0}
                                                            target={`tooltip-delete-${seller._id}`}
                                                        >
                                                            Delete
                                                        </UncontrolledTooltip>
                                                    </> : null}
                                                </td>
                                            </tr>
                                        )
                                    })
                                : 
                                <tr>
                                    <td colSpan="6">There's no seller to show</td>
                                </tr>
                                }
                            </tbody>
                        </Table>
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                <ConfirmationModal
                    ref={el => this.deleteConfirmationModal = el}
                    title="Delete Seller?"
                    buttons={[
                        { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                        { title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteSeller }
                    ]}
                >
                    Are you sure you want to delete this seller?
                </ConfirmationModal>
                </div>
            </>
        )
    }
}

export default Sellers;